import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CommunicationsService {
  constructor(private http: HttpClient) {}

  public getCommunications(roadId: string): Observable<any[]> {
    return this.http.get<any[]>(environment.apiConfig.uri + `/v1/roads/${roadId}/communications`);
  }

  public patchCommunications(roadId: string, system: string, enabled: boolean): Observable<any[]> {
    return this.http.patch<any[]>(
      environment.apiConfig.uri + `/v1/roads/${roadId}/communications/${system}?enabled=${enabled}`,
      {},
    );
  }
}
